<template>
  <div class="cargoInquiryList">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="$t.cargoInquiry.inputText"
          >
            <template #action>
              <div @click="onSearch">{{ $t.cargoInquiry.searchText }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.cargoInquiry.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-tabs
      v-model="state"
      @change="stateChanged"
      title-active-color="#ffffff"
      title-inactive-color="#666666"
      color="#1a347b"
      swipeable
      sticky
      :offset-top="49"
      :ellipsis="false"
      type="card"
    >
      <van-tab
        v-for="(menu, index) in stateList"
        :key="index"
        :title="menu.title + (menu.count > 0 ? ' ' + menu.count : '')"
        :name="menu.name"
      >
        <van-list
          class="list"
          v-model="loading"
          :finished="finished"
          :finished-text="$t.meta.noMore"
          :error.sync="error"
          :error-text="errorText"
          @load="getList(page + 1)"
        >
          <div class="detail" v-for="(detail, index) in tableData" :key="index">
            <div class="head">
              <div class="wbNumber">
                {{ $t.cargoInquiry.wbNumber }}：{{ detail.WB_Number }}
              </div>
            </div>
            <div class="left">
              <div class="delivery-city">{{ detail.DeliveryCityName }}</div>
              <div class="delivery-country">
                {{ detail.DeliveryCountryName }}
              </div>
            </div>
            <div class="center">
              <div class="logistics-icon">
                <img src="~assets/img/cargoInquiry/arrow.png" />
              </div>
              <div class="logistics-state">
                <span v-if="detail.LogisticsState == 1">{{
                  $t.cargoInquiry.logisticsState1
                }}</span>
                <span v-if="detail.LogisticsState == 2">{{
                  $t.cargoInquiry.logisticsState2
                }}</span>
                <span v-if="detail.LogisticsState == 3">{{
                  $t.cargoInquiry.logisticsState3
                }}</span>
                <span v-if="detail.LogisticsState == 4">{{
                  $t.cargoInquiry.logisticsState4
                }}</span>
                <span v-if="detail.LogisticsState == 5">{{
                  $t.cargoInquiry.logisticsState5
                }}</span>
              </div>
            </div>
            <div class="right">
              <div class="destination-city">
                {{ detail.DestinationCityName }}
              </div>
              <div class="destination-country">
                {{ detail.DestinationCountryName }}
              </div>
            </div>
            <div class="footer">
              <div class="logistics-info">
                <span v-if="detail.LogisticsState == 1">{{
                  $t.cargoInquiry.logisticsState1
                }}</span>
                <span v-if="detail.LogisticsState == 2">{{
                  $t.cargoInquiry.logisticsState2
                }}</span>
                <span v-if="detail.LogisticsState == 3">{{
                  $t.cargoInquiry.logisticsState3
                }}</span>
                <span v-if="detail.LogisticsState == 4">{{
                  $t.cargoInquiry.logisticsState4
                }}</span>
                <span v-if="detail.LogisticsState == 5">{{
                  $t.cargoInquiry.logisticsState5
                }}</span>
                ：&nbsp;<span class="val">{{ detail.LogisticsInfo }}</span>
              </div>
              <div class="logistics-time">
                <span v-if="detail.LogisticsState == 5">{{
                  $t.cargoInquiry.signTime
                }}</span>
                <span v-else>{{ $t.cargoInquiry.updateTime }}</span
                >：&nbsp;<span class="val"> {{ detail.LogisticsTime }}</span>
              </div>
            </div>
            <div class="buttons">
              <van-button
                class="search-btn"
                size="small"
                type="success"
                @click="gotoCargoInquiry(detail.WB_Number)"
                >{{ $t.cargoInquiry.viewLogistics }}</van-button
              >
            </div>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.cargoInquiry.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.cargoInquiry.logisticsStatus }}</div>
        <van-radio-group v-model="logisticsState" direction="horizontal">
          <van-radio name="1">{{ $t.cargoInquiry.logisticsState1 }}</van-radio>
          <van-radio name="2">{{ $t.cargoInquiry.logisticsState2 }}</van-radio>
          <van-radio name="3">{{ $t.cargoInquiry.logisticsState3 }}</van-radio>
          <van-radio name="4">{{ $t.cargoInquiry.logisticsState4 }}</van-radio>
        </van-radio-group>

        <div class="radio-label">{{ $t.cargoInquiry.dateRange }}</div>
        <van-radio-group v-model="timeType" direction="horizontal">
          <van-radio name="1">{{ $t.cargoInquiry.dateType1 }}</van-radio>
          <van-radio name="2">{{ $t.cargoInquiry.dateType2 }}</van-radio>
          <van-radio name="3">{{ $t.cargoInquiry.dateType3 }}</van-radio>
          <van-radio name="4">{{ $t.cargoInquiry.dateType4 }}</van-radio>
        </van-radio-group>

        <div class="custom-date" v-if="timeType == '4'">
          <van-button class="date-btn1" type="info" size="small" @click="showStartDate">{{
            $t.cargoInquiry.startDate
          }}</van-button>
          <van-button class="date-btn2" type="info" size="small" @click="showEndDate">{{
            $t.cargoInquiry.endDate
          }}</van-button>
          <div class="date-txt" v-if="beginTime || endTime">
            {{ beginTime }} {{ $t.cargoInquiry.to }} {{ endTime }}
          </div>

          <van-popup v-model="showStartPicker" position="bottom">
            <van-datetime-picker
              type="date"
              :title="$t.cargoInquiry.startDate"
              :formatter="formatter"
              :confirm-button-text="$t.alert.confirmButtonText"
              :cancel-button-text="$t.alert.cancelButtonText"
              @confirm="dateChange($event, 'start')"
              @cancel="showStartPicker = false"
              :min-date="currentDate"
            />
          </van-popup>

          <van-popup v-model="showEndPicker" position="bottom">
            <van-datetime-picker
              type="date"
              :title="$t.cargoInquiry.endDate"
              :formatter="formatter"
              :confirm-button-text="$t.alert.confirmButtonText"
              :cancel-button-text="$t.alert.cancelButtonText"
              @confirm="dateChange($event, 'end')"
              @cancel="showEndPicker = false"
              :min-date="currentDate"
            />
          </van-popup>
        </div>
      </van-form>

      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.cargoInquiry.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.cargoInquiry.confirm
        }}</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
import Vue from "vue";
import {
  List,
  Popup,
  Form,
  Button,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
  DatetimePicker,
  Row,
  Col,
  Search,
} from "vant";

Vue.use(List)
  .use(Popup)
  .use(Form)
  .use(Button)
  .use(Radio)
  .use(RadioGroup)
  .use(Tab)
  .use(Tabs)
  .use(DatetimePicker)
  .use(Row)
  .use(Col)
  .use(Search);

export default {
  name: "cargoInquiryList",
  data() {
    return {
      state: this.$route.query.state
        ? this.$route.query.state
        : parseInt(localStorage.getItem("MenuState")),
      stateList: [
        {
          title: this.$t.cargoInquiry.tab1,
          name: 1,
          count: 0,
        },
        {
          title: this.$t.cargoInquiry.tab2,
          name: 2,
          count: 0,
        },
      ],
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //筛选
      orderBy: "",
      searchText: "",
      logisticsState: null,
      timeType: null,
      showFilter: false,
      //日期
      currentDate: "",
      showStartPicker: false,
      beginTime: "",
      showEndPicker: false,
      endTime: "",
    };
  },
  watch: {
    state() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
      this.getList(1);
    },
  },
  mounted() {
    const query = this.$route.query;
    if (query.SearchText) {
      this.searchText = query.SearchText;
    }
  },
  methods: {
    showStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 1825);
      this.currentDate = start;
      this.showStartPicker = true;
    },
    showEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 1825);
      this.currentDate = end;
      this.showEndPicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.cargoInquiry.year;
      }
      if (type === "month") {
        return val + this.$t.cargoInquiry.month;
      }
      if (type === "day") {
        return val + this.$t.cargoInquiry.day;
      }
      return val;
    },
    dateChange(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "start") {
        this.beginTime = formatDate(date);
        this.showStartPicker = false;
      }
      if (type == "end") {
        this.endTime = formatDate(date);
        this.showEndPicker = false;
      }
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    isFilter() {
      if (this.logisticsState || this.timeType) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.logisticsState = null;
      this.timeType = null;
      this.beginTime = "";
      this.endTime = "";
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      if (this.timeType == 4) {
        if (!this.beginTime) {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.cargoInquiry.selectStartDate,
            type: "danger",
          });
          return;
        }
        if (!this.endTime) {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.cargoInquiry.selectEndDate,
            type: "danger",
          });
          return;
        }
      }
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    stateChanged(state) {
      this.state = state;
      localStorage.setItem("MenuState", JSON.stringify(state));
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        CompletionState: this.state,
        LogisticsState: this.logisticsState,
        WB_Number: this.searchText,
        TimeType: this.timeType,
        BeginTime: this.beginTime,
        EndTime: this.endTime,
      };
      return new Promise((resolve) => {
        this.$api.inquiry
          .getCargoLogisticsListByPage(param)
          .then((res) => {
            this.tableData = this.tableData.concat(res.data.Data);
            this.loading = false;
            this.error = false;
            this.errorText = "";

            this.page = res.meta.page;
            this.finished = this.page >= res.meta.lastPage;
            for (var state of this.stateList) {
              if (state.name == "1" && param.CompletionState == "1") {
                state.count = res.meta.total;
              }
            }
            resolve(true);
          })
          .catch((error) => {
            this.loading = false;
            this.error = true;
            this.errorText = error.message;
          });
      });
    },
    gotoCargoInquiry(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "cargoInquiry",
        name: "cargoInquiry",
        query: [
          {
            name: "wbNumber",
            value: id,
          },
        ],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.cargoInquiryList {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            color: #969799;
            padding: 5px 8px 5px 8px;
          }
        }
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .van-tabs {
    ::v-deep .van-tabs__wrap {
      height: auto;
    }
    ::v-deep .van-tabs__nav {
      margin: 0;
      height: auto;
      border-left: none !important;
      border-right: none !important;
      border-color: #e4e9f0 !important;
      .van-tab--active {
        box-shadow: 0px 2.5px 6.5px 1px rgb(0 0 0 / 10%);
      }
      .van-tab {
        height: 38px;
        line-height: 38px;
        margin: 8px 0px 8px 8px;
        padding: 8px 16px;
        border: none;
        background: #f7f9fb;
        border-radius: 100px;
        border: 1px solid #e4e9f0 !important;
        .van-tab__text {
          font-size: 12px;
          font-weight: 500;
        }
      }
      .van-tab:last-child {
        margin: 8px !important;
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
    ::v-deep .van-radio__icon--checked {
      .van-icon-success {
        background-color: #2750aa !important;
        border-color: #2750aa !important;
      }
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        background-color: #2750aa;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        background-color: #2750aa;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #898da1;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    bottom: calc(0px + env(safe-area-inset-bottom));
    width: 100%;
    text-align: center;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .van-pull-refresh {
    overflow: unset;
  }
  .list {
    padding: 0px 15px;
    .detail {
      padding: 20px;
      margin-top: 15px;
      border-radius: 20px;
      background: white;
      border: 1px solid #e5e5e5;
      box-shadow: 0px 2.5px 5px 0px rgba(0, 0, 0, 0.1);
      font-size: 14px;
      .head {
        vertical-align: middle;
        display: inline-block;
        width: 100%;
        margin-bottom: 30px;
        .wbNumber {
          color: #898da1;
          font-size: 12px;
        }
      }
      .left {
        vertical-align: middle;
        display: inline-block;
        width: 40%;
        text-align: center;
        .delivery-city {
          color: #000;
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 5px;
        }
        .delivery-country {
          color: #898da1;
          font-size: 12px;
        }
      }
      .center {
        vertical-align: middle;
        display: inline-block;
        width: 20%;
        text-align: center;
        .logistics-icon {
          margin-bottom: 5px;
          img {
            width: 40px;
            height: 10px;
            object-fit: contain;
          }
        }
        .logistics-state {
          color: #000;
          font-size: 12px;
        }
      }
      .right {
        vertical-align: top;
        display: inline-block;
        width: 40%;
        text-align: center;
        .destination-city {
          color: #000;
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 5px;
        }
        .destination-country {
          color: #898da1;
          font-size: 12px;
        }
      }
      .footer {
        vertical-align: middle;
        display: inline-block;
        width: 100%;
        margin-top: 30px;
        .logistics-info {
          color: #898da1;
          font-size: 12px;
          margin-bottom: 10px;
          .val {
            color: #000;
          }
        }
        .logistics-time {
          color: #898da1;
          font-size: 12px;
          .val {
            color: #000;
          }
        }
      }
      .buttons {
        text-align: center;
        margin-top: 20px;
        .van-button {
          border: none;
          border-radius: 10px;
          height: 35px;
          line-height: 35px;
          width: 100%;
        }
        .search-btn {
          background: #00ae61;
          color: #fff;
          font-weight: 500;
          .van-button__text {
            font-size: 12px !important;
          }
        }
      }
    }
  }
}
</style>
